export default "__VITE_ASSET__CqY$b_wA__"